"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    avatar: {
      width: 16,
      height: 16
    },
    userName: {
      maxWidth: 80
    }
  };
});

var LineProfile = function LineProfile(_ref) {
  var firstName = _ref.firstName,
      lastName = _ref.lastName,
      image = _ref.image,
      props = (0, _objectWithoutProperties2.default)(_ref, ["firstName", "lastName", "image"]);
  var classes = useStyles();
  var name = (0, _react.useMemo)(function () {
    if (!lastName) {
      return firstName;
    }

    return "".concat(firstName, " ").concat(lastName[0], ".");
  }, [firstName, lastName]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, (0, _extends2.default)({
    container: true,
    spacing: 1,
    direction: "row"
  }, props), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    alt: "".concat(name, "'s avatar"),
    src: image,
    className: classes.avatar
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: true,
    zeroMinWidth: true
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    noWrap: true,
    className: (0, _classnames.default)('Body-Small-Static', classes.userName)
  }, name)));
};

var _default = /*#__PURE__*/(0, _react.memo)(LineProfile);

exports.default = _default;